/* eslint-disable no-param-reassign */
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: any = {
  master: [],
  systemConfiguration: [],
  blitzMasterConfiguration: {} as Record<string, string>,
  errorsByInstanceId: {} as Record<string, any>,
  persistErrorsByInstanceId: {} as Record<string, any>,
  containerErrorsByInstanceId: {} as Record<string, any>,
}

export const masterSlice = createSlice({
  name: 'master',
  initialState,
  reducers: {
    setMaster: (state, action: PayloadAction<any>) => {
      state.master = action.payload
    },
    setSystemConfiguration: (state, action: PayloadAction<string>) => {
      state.systemConfiguration = action.payload
    },
    setBlitzMasterConfiguration: (state, action: PayloadAction<Record<string, string>>) => {
      state.blitzMasterConfiguration = action.payload
    },
    setHookFormErrors: (state, action: PayloadAction<{ instanceId: string; errors: any }>) => {
      const { instanceId, errors } = action.payload
      if (!state.errorsByInstanceId) state.errorsByInstanceId = {}
      state.errorsByInstanceId[instanceId] = errors
    },
    setHookFormPersistErrors: (
      state,
      action: PayloadAction<{ instanceId: string; errors: any }>,
    ) => {
      const { instanceId, errors } = action.payload
      if (!state.persistErrorsByInstanceId) state.persistErrorsByInstanceId = {}
      state.persistErrorsByInstanceId[instanceId] = errors
    },
    setContainerErrors: (state, action: PayloadAction<{ instanceId: string; errors: any }>) => {
      const { instanceId, errors } = action.payload
      if (!state.containerErrorsByInstanceId) state.containerErrorsByInstanceId = {}
      state.containerErrorsByInstanceId[instanceId] = errors
    },
  },
})

export const {
  setMaster,
  setSystemConfiguration,
  setBlitzMasterConfiguration,
  setHookFormErrors,
  setHookFormPersistErrors,
  setContainerErrors,
} = masterSlice.actions

export default masterSlice

const masterSelector = (state: any) => state.master

export const selectMasterData = createSelector(masterSelector, (state) => state.master)

export const selectSystemConfigurationData = createSelector(
  [masterSelector],
  (state) => state.systemConfiguration,
)

export const selectBlitzMasterConfigurationData = createSelector(
  [masterSelector],
  (state) => state.blitzMasterConfiguration,
)

export const makeSelectHookFormErrors = (instanceId: string) =>
  createSelector(masterSelector, (state) => state.errorsByInstanceId?.[instanceId] ?? null)

export const makeSelectHookFormPersistErrors = (instanceId: string) =>
  createSelector(masterSelector, (state) => state.persistErrorsByInstanceId?.[instanceId] ?? null)

export const makeSelectContainerErrors = (instanceId: string) =>
  createSelector(masterSelector, (state) => state.containerErrorsByInstanceId?.[instanceId] ?? null)
